import theme from '../index';

export interface MuiComponentSettings {
	[key: string]: string | number | object;
}

export const MuiButton: MuiComponentSettings = {
	styleOverrides: {
		root: {
			fontSize: '16px',
			borderRadius: 'var(--default--border-radius)',
			fontFamily: 'Lato',
			lineHeight: '28px',
			backgroundColor: 'inherit',
			width: '100%',
			textTransform: 'Capitalize',
			alignItems: 'center',
			fontWeight: '700',
		},
	},
	variants: [
		{
			props: {variant: 'filled', color: 'primary'},
			style: () => ({
				color: theme.palette.neutral50,
				backgroundColor: theme.palette.primary500,
				'&:hover': {
					backgroundColor: theme.palette.primary400,
				},
				'&:active': {
					backgroundColor: theme.palette.primary600,
				},
				'&:disabled': {
					backgroundColor: theme.palette.primary200,
					color: theme.palette.neutral50,
				},
			}),
		},
		{
			props: {variant: 'filled', color: 'error'},
			style: () => ({
				color: theme.palette.neutral50,
				backgroundColor: theme.palette.error500,
				'&:hover': {
					backgroundColor: theme.palette.error400,
				},
				'&:active': {
					backgroundColor: theme.palette.error600,
				},
				'&:disabled': {
					backgroundColor: theme.palette.error200,
					color: theme.palette.neutral50,
				},
			}),
		},
		{
			props: {variant: 'filled', color: 'warning'},
			style: () => ({
				color: theme.palette.neutral50,
				backgroundColor: theme.palette.warning500,
				'&:hover': {
					backgroundColor: theme.palette.warning400,
				},
				'&:active': {
					backgroundColor: theme.palette.warning600,
				},
				'&:disabled': {
					backgroundColor: theme.palette.warning200,
					color: theme.palette.neutral50,
				},
			}),
		},
		{
			props: {variant: 'outline', color: 'primary'},
			style: () => ({
				color: theme.palette.primary500,
				border: `1px solid ${theme.palette.primary500}`,
				'&:hover': {
					border: `1px solid ${theme.palette.primary400}`,
					backgroundColor: theme.palette.primary100,
					color: theme.palette.primary400,
				},
				'&:active': {
					border: `1px solid ${theme.palette.primary600}`,
					backgroundColor: theme.palette.primary100,
					color: theme.palette.primary600,
				},
				'&:disabled': {
					border: `1px solid ${theme.palette.primary200}`,
					color: theme.palette.primary200,
				},
			}),
		},
		{
			props: {variant: 'outline', color: 'error'},
			style: () => ({
				color: theme.palette.error500,
				border: `1px solid ${theme.palette.error500}`,
				'&:hover': {
					border: `1px solid ${theme.palette.error400}`,
					backgroundColor: theme.palette.error100,
					color: theme.palette.error400,
				},
				'&:active': {
					border: `1px solid ${theme.palette.error600}`,
					backgroundColor: theme.palette.error100,
					color: theme.palette.error600,
				},
				'&:disabled': {
					border: `1px solid ${theme.palette.error200}`,
					color: theme.palette.error200,
				},
			}),
		},
		{
			props: {variant: 'outline', color: 'warning'},
			style: () => ({
				color: theme.palette.warning500,
				border: `1px solid ${theme.palette.warning500}`,
				'&:hover': {
					border: `1px solid ${theme.palette.warning400}`,
					backgroundColor: theme.palette.warning100,
					color: theme.palette.warning400,
				},
				'&:active': {
					border: `1px solid ${theme.palette.warning600}`,
					backgroundColor: theme.palette.warning100,
					color: theme.palette.warning600,
				},
				'&:disabled': {
					border: `1px solid ${theme.palette.warning200}`,
					color: theme.palette.error200,
				},
			}),
		},
		{
			props: {variant: 'text', color: 'primary'},
			style: () => ({
				color: theme.palette.primary500,
				padding: 'unset',
				width: 'auto',

				'&:hover': {
					backgroundColor: 'unset',
					color: theme.palette.primary400,
				},
				'&:active': {
					color: theme.palette.primary600,
				},
				'&:disabled': {
					color: theme.palette.primary200,
				},
			}),
		},
		{
			props: {variant: 'text', color: 'success'},
			style: () => ({
				color: theme.palette.success500,
				padding: 'unset',
				width: 'auto',

				'&:hover': {
					backgroundColor: 'unset',
					color: theme.palette.success400,
				},
				'&:active': {
					color: theme.palette.success600,
				},
				'&:disabled': {
					color: theme.palette.success200,
				},
			}),
		},
		{
			props: {variant: 'text', color: 'error'},
			style: () => ({
				color: theme.palette.error500,
				padding: 'unset',
				width: 'auto',

				'&:hover': {
					backgroundColor: 'unset',
					color: theme.palette.error400,
				},
				'&:active': {
					color: theme.palette.error600,
				},
				'&:disabled': {
					color: theme.palette.error200,
				},
			}),
		},
		{
			props: {variant: 'text', color: 'warning'},
			style: () => ({
				color: theme.palette.warning500,
				padding: 'unset',
				width: 'auto',

				'&:hover': {
					backgroundColor: 'unset',
					color: theme.palette.warning400,
				},
				'&:active': {
					color: theme.palette.warning600,
				},
				'&:disabled': {
					color: theme.palette.error200,
				},
			}),
		},
	],
};
